var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuywater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.707 2.293C9.61426 2.2 9.50406 2.12624 9.38273 2.07596C9.26141 2.02568 9.13134 1.99986 9 2H4C3.86867 1.99986 3.7386 2.02568 3.61727 2.07596C3.49594 2.12624 3.38574 2.2 3.293 2.293L0.293001 5.293C0.199958 5.38571 0.126171 5.4959 0.0758854 5.61724C0.0256001 5.73857 -0.000189449 5.86866 1.04767e-06 6V11C1.04767e-06 11.266 0.105001 11.52 0.293001 11.707L10.293 21.707C10.3857 21.8002 10.4958 21.8741 10.6171 21.9246C10.7385 21.9751 10.8686 22.001 11 22.001C11.1314 22.001 11.2615 21.9751 11.3829 21.9246C11.5042 21.8741 11.6143 21.8002 11.707 21.707L19.707 13.707C19.7999 13.6142 19.8737 13.504 19.924 13.3827C19.9743 13.2614 20.0002 13.1313 20.0002 13C20.0002 12.8687 19.9743 12.7386 19.924 12.6173C19.8737 12.496 19.7999 12.3858 19.707 12.293L9.707 2.293V2.293ZM11 19.586L2 10.586V6.414L4.414 4H8.586L17.586 13L11 19.586Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.35403 9.99908C7.26364 9.99908 8.00103 9.26169 8.00103 8.35208C8.00103 7.44247 7.26364 6.70508 6.35403 6.70508C5.44442 6.70508 4.70703 7.44247 4.70703 8.35208C4.70703 9.26169 5.44442 9.99908 6.35403 9.99908Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuywater);
export default __webpack_public_path__ + "static/media/buywater.b83a7dcec8793f6cdd075a6c17a8984c.svg";
export { ForwardRef as ReactComponent };